var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightLightBlackChevronIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20041 6.23966C8.48226 5.93613 8.95681 5.91856 9.26034 6.20041L12.7603 9.45041C12.9132 9.59232 13 9.79145 13 10C13 10.2086 12.9132 10.4077 12.7603 10.5496L9.26034 13.7996C8.95681 14.0815 8.48226 14.0639 8.20041 13.7603C7.91856 13.4568 7.93613 12.9823 8.23966 12.7004L11.1478 10L8.23966 7.2996C7.93613 7.01775 7.91856 6.5432 8.20041 6.23966Z",
    fill: "#A6A5A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLightBlackChevronIcon);
export default __webpack_public_path__ + "static/media/RightLightBlackChevronIcon.7e7f4b9696574a12cc62ce436a552879.svg";
export { ForwardRef as ReactComponent };